export const API_SEARCH_POSTALCODE = 'API_SEARCH_POSTALCODE'
export const API_SEARCH_POSTALCODE_SUCCESS = 'API_SEARCH_POSTALCODE_SUCCESS'
export const API_SEARCH_POSTALCODE_FAIL = 'API_SEARCH_POSTALCODE_FAIL'
